<style scoped>
    .btn {
        margin-left: 10px;
    }

    .arrow {
        margin-bottom: 10px;
    }
</style>
<template>
    <div class="row my-1">
        <div class="col-11 pr-0">
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col-9">
                            <b-input-group :prepend="qPrepend">
                                <b-input class="h5" v-model="question" @keydown.enter.native="aaa()" disable></b-input>
                            </b-input-group>
                            <b-input-group :prepend="aPrepend">
                                <b-input class="mb-0" v-model="answer" @keydown.enter.native="aaa()"></b-input>
                            </b-input-group>
                        </div>
                        <div class="col-3 d-flex justify-content-end">
                            <b-btn class="btn" :variant="quiz !== undefined && quiz.type === 'quiz' ? 'primary' : 'success'"
                                   :disabled="editDisabled"
                                   @click="editQuiz()">
                                저장
                            </b-btn>
                            <b-btn class="btn" variant="danger"
                                   :disabled="submitbtnDisabled"
                                   @click="removeQuiz()">
                                삭제
                            </b-btn>
                        </div>
                    </div>
                </div>
                <div v-if="isQuiz" class="col-12">
                    <b-input-group prepend="보기1">
                        <b-input class="mb-0" v-model="selection0" @keydown.enter.native="aaa()"></b-input>
                    </b-input-group>
                    <b-input-group prepend="보기2">
                        <b-input class="mb-0" v-model="selection1" @keydown.enter.native="aaa()"></b-input>
                    </b-input-group>
                    <b-input-group prepend="보기3">
                        <b-input class="mb-0" v-model="selection2" @keydown.enter.native="aaa()"></b-input>
                    </b-input-group>
                </div>
            </div>
        </div>
        <div class="col-1 arrow">
            <b-btn @click="upQuiz()">
                ⬆
            </b-btn>
            <b-btn @click="downQuiz()">
                ⬇
            </b-btn>
        </div>
    </div>
</template>

<script>
// import { mapState } from 'vuex'
import l from '@/vendor/logger'

export default {
  name: 'EditableQuiz',
  props: {
    quiz: Object,
    number: Number
  },
  data () {
    return {
      submitbtnDisabled: false,
      editDisabled: true,
      rightAnswer: 0,
      selection: [0, 1, 2],
      selection0: 's 0',
      selection1: 's 1',
      selection2: 's 2',
      isQuiz: this.isQuizType(),
      answer: this.answerValue(),
      question: this.questionValue(),
      qPrepend: this.questionPrepend(),
      aPrepend: this.answerPrepend()
    }
  },
  created () {
    if (this.quiz && this.quiz.type === 'quiz') {
      this.quiz.selection.forEach((v, i) => {
        switch (i) {
          case 0:
            this.selection0 = v
            break
          case 1:
            this.selection1 = v
            break
          case 2:
            this.selection2 = v
            break
          default :
            break
        }
      })
    }
  },
  methods: {
    removeQuiz () {
      this.$store.dispatch('quizbank/removeQuiz', this.quiz.id)
    },
    editQuiz () {
      let tmpQuiz = { ...this.quiz }
      if (this.isQuizType()) {
        tmpQuiz.question = this.question
        tmpQuiz.selection = [this.selection0, this.selection1, this.selection2]
        tmpQuiz.answer = this.answer - 1
      } else {
        tmpQuiz.title = this.question
        tmpQuiz.value = this.answer
      }
      this.$store.dispatch('quizbank/modifyQuiz', tmpQuiz)
      this.editDisabled = true
    },

    async upQuiz () {
      let aboveId = 'null'
      if (this.quiz.link && this.quiz.link.front) {
        aboveId = this.quiz.link.front
      }
      await this.$store.dispatch('quizbank/moveQuiz', { quizId: this.quiz.id, aboveId })
      this.editDisabled = true
    },

    downQuiz () {
      let aboveId = 'null'
      if (this.quiz.link && this.quiz.link.rear) {
        aboveId = this.quiz.link.rear
      }

      this.$store.dispatch('quizbank/moveQuiz', { quizId: aboveId, aboveId: this.quiz.id })
      this.editDisabled = true
    },
    isQuizType () {
      if (this.quiz === undefined) {
        return true
      } else {
        return this.quiz.type === 'quiz'
      }
    },
    answerValue () {
      return this.isQuizType() ? parseInt(this.quiz.answer) + 1 : this.quiz.value
    },
    questionValue () {
      return this.isQuizType() ? this.quiz.question : this.quiz.title
    },
    questionPrepend () {
      return this.isQuizType() ? '문제 ' + (this.quiz.index) : '제목'
    },
    answerPrepend () {
      return this.isQuizType() ? '정답' : '값'
    },
    aaa () {
      l.d('EditableQuiz/aaa', this.question)
      this.editDisabled = false
    }
  }
}
</script>

<style scoped>

</style>
